import { render, staticRenderFns } from "./Escola.vue?vue&type=template&id=9775118e&scoped=true&"
import script from "./Escola.vue?vue&type=script&lang=js&"
export * from "./Escola.vue?vue&type=script&lang=js&"
import style0 from "./Escola.vue?vue&type=style&index=0&id=9775118e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9775118e",
  null
  
)

export default component.exports